(function () {
  const BADGE_HTML =
    '<span class="hi-verified-badge">✔ Verified</span>';

  function applyBadges() {
    document.querySelectorAll('.jdgm-rev__author').forEach(el => {
      if (!el.nextElementSibling || !el.nextElementSibling.classList.contains('hi-verified-badge')) {
        el.insertAdjacentHTML('afterend', BADGE_HTML);
      }
    });
  }

  // Run repeatedly (handles lazy-loaded reviews)
  setInterval(applyBadges, 2000);
})();